/**
 * Admin API client — a thin wrapper around the shared axios instance that
 * scopes every call to /api/admin/scrud/<route>. Keeping this in its own
 * file makes the admin surface easy to swap, mock or extend independently
 * from the rest of the app.
 */
import api from "@/lib/api";

const BASE = "/admin/scrud";

const adminApi = {
    manifest: () => api.get(`${BASE}/_manifest`).then((r) => r.data),

    list: (route) => api.get(`${BASE}/${route}`).then((r) => r.data),

    get: (route, id) => api.get(`${BASE}/${route}/${id}`).then((r) => r.data),

    create: (route, payload) =>
        api.post(`${BASE}/${route}`, payload).then((r) => r.data),

    update: (route, id, payload) =>
        api.put(`${BASE}/${route}/${id}`, payload).then((r) => r.data),

    remove: (route, id) => api.delete(`${BASE}/${route}/${id}`),
};

export default adminApi;
